
import { IS_PROD, IS_SA } from '../config/appConfig';
import { LocalStorageKey } from '../constants/localStorageKeys';
import { getLoginInfo, getRegistrationData, getRegistrationInfo, getUser } from '../services/authService';
import { DateHelper } from './dateHelper';


export const pushToDataLayer = (event, userData) => {

  if (!IS_PROD) {
    return;
  }

  let investorType = getLoginInfo()?.investorType || getRegistrationInfo()?.investorType || getRegistrationData()?.investorType || null;

  if (window && window.dataLayer) {
    window.dataLayer.push({
      event,
      accountType: IS_SA ? 'Saudi Arabia' : 'Global',
      investorType: investorType ? `${investorType} Investor` : null,
      ...userData
    });
  } else {
    console.warn("GTM dataLayer is not available.");
  }
};


export const saveContactNumber = (number) => {
  localStorage.setItem(LocalStorageKey.userContactNumber, number ? JSON.stringify(number) : null);
};

export const getContactNumber = () => {
  return localStorage.getItem(LocalStorageKey.userContactNumber) ? JSON.parse(localStorage.getItem(LocalStorageKey.userContactNumber)) : null;
};

export const setPersonalInformation = (personalInformation) => {
  localStorage.setItem(LocalStorageKey.userPersonalInfo, personalInformation ? JSON.stringify(personalInformation) : null);
};

export const getPersonalInformation = () => {
  return localStorage.getItem(LocalStorageKey.userPersonalInfo) ? JSON.parse(localStorage.getItem(LocalStorageKey.userPersonalInfo)) : null;
};

export const formatGTMUserInfo = (userInfo) => {
  const personalInformation = userInfo ? userInfo : getPersonalInformation();

  if (!personalInformation) {
    return null;
  }

  const addressInfo = personalInformation?.address;
  const contactNumber =
    personalInformation?.contactNumber ?
      `+${personalInformation?.contactNumber?.code} ${personalInformation?.contactNumber?.number}` : null;

  return {
    userInfo: {
      email: getUser()?.email,
      phone: contactNumber || getContactNumber(),
      firstName: personalInformation?.firstName,
      lastName: personalInformation?.firstName,
      dateOfBirth: personalInformation?.birthDate ? DateHelper.formatDate(personalInformation?.birthDate, 'dd/MM/yyyy') : '',
      address: addressInfo?.addressLine || '',
      country: addressInfo?.country?.name || '',
    }
  };
};